import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { UI_SCALES, getUiScale, setUiScale } from '@/lib/uiScale'
import { cn } from '@/lib/utils'

/** Nastavenia → Môj účet: veľkosť textu (celého rozhrania) na tomto zariadení. */
export function TextSizeSection() {
  const { t } = useTranslation()
  const [scale, setScale] = useState(getUiScale)

  function pick(value: number) {
    setUiScale(value)
    setScale(value)
  }

  return (
    <section className="card space-y-2 p-4">
      <h2 className="text-sm font-semibold">{t('settings.textSize')}</h2>
      <div className="flex flex-wrap gap-1.5">
        {UI_SCALES.map((value) => (
          <button
            key={value}
            type="button"
            onClick={() => pick(value)}
            className={cn(
              'rounded border px-3 py-1.5',
              value === scale
                ? 'border-brand-500 bg-brand-50 font-medium text-brand-700'
                : 'border-slate-300 bg-white text-slate-600 hover:bg-slate-50',
            )}
            style={{ fontSize: `${13 * value}px` }}
          >
            {Math.round(value * 100)} %
          </button>
        ))}
      </div>
      <p className="text-xs text-slate-500">{t('settings.textSizeHint')}</p>
    </section>
  )
}
